import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Drawer, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LeftHeader from './LeftHeader';
import RightHeader from './RightHeader';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <AppBar 
      position="static" 
      sx={{ 
        backgroundColor: '#063142',
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        overflowX: 'hidden'
      }}
      data-testid="header-app-bar"
    >
      <Toolbar 
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          maxWidth: '100vw',
          padding: { xs: '0 8px', sm: '0 24px' },
          minHeight: { xs: '56px', sm: '64px' },
          boxSizing: 'border-box',
          overflowX: 'hidden'
        }}
        data-testid="header-toolbar"
      >
        <Box 
          sx={{ 
            flex: '1 1 auto',
            overflow: 'hidden',
            maxWidth: 'calc(100vw - 56px)' // Account for menu button width
          }}
          data-testid="header-left-container"
        >
          <LeftHeader />
        </Box>
        
        {/* Mobile Menu Button */}
        <IconButton
          sx={{
            display: { xs: 'flex', md: 'none' },
            color: 'white',
            padding: '8px',
            flex: '0 0 auto'
          }}
          edge="end"
          onClick={toggleMobileMenu}
          aria-label="menu"
          data-testid="header-mobile-menu-button"
        >
          <MenuIcon />
        </IconButton>

        {/* Desktop Right Header */}
        <Box 
          sx={{ 
            display: { xs: 'none', md: 'block' },
            flex: '0 0 auto'
          }}
          data-testid="header-desktop-right-container"
        >
          <RightHeader />
        </Box>

        {/* Mobile Sidebar */}
        <Drawer
          anchor="right"
          open={isMobileMenuOpen}
          onClose={toggleMobileMenu}
          sx={{
            '& .MuiDrawer-paper': {
              width: '80%',
              maxWidth: '300px',
              backgroundColor: '#063142',
              color: 'white',
              padding: '1rem',
            },
          }}
          data-testid="header-mobile-drawer"
        >
          <Box 
            sx={{ py: 2, width: '100%' }}
            data-testid="header-mobile-drawer-content"
          >
            <RightHeader />
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Header;

